import React from 'react';
import './style.css';
export default function Footer() {
  return (
    <div id='footer-container'>
      <p>Developed using React - All CopyRights &copy; reserved</p>
    </div>
  );
}
